// Match a variant's finish to a product image by the finish words in each.
// Used by the product page so choosing "Silver" shows the silver packshot.
// ES module (React only): CJS files bundled by CRA must avoid destructuring.
// Order matters: longer, more specific phrases first so "satin nickel" wins
// over "nickel" and "gun metal" does not read as "metal".
const FINISHES = [
  ['gun metal', ['gun metal', 'gunmetal', '-gm', ' gm ']],
  ['satin brass', ['satin brass', 'brass', '-sb', ' sb ']],
  ['satin nickel', ['satin nickel', 'nickel', 'satin stainless']],
  ['stainless', ['stainless', '-ss', ' ss ', 'steel']],
  ['black', ['black', '-blk', ' blk', 'matte black', 'matt black']],
  ['silver', ['silver', '-slv', ' slv']],
  ['grey', ['grey', 'gray']],
  ['white', ['white']],
  ['gold', ['gold']],
  ['chrome', ['chrome']],
];

export function finishOf(text) {
  const t = ` ${String(text || '').toLowerCase()} `;
  for (const [name, words] of FINISHES) {
    if (words.some((w) => t.includes(w))) return name;
  }
  return null;
}

// Index of the image whose finish matches the variant's, or -1.
export function imageIndexForVariant(images, variant) {
  if (!variant || !images || images.length < 2) return -1;
  const want = finishOf(`${variant.label} ${variant.supplierSku || ''}`);
  if (!want) return -1;
  return images.findIndex((im) => finishOf(im.alt) === want);
}

